export default __webpack_public_path__ + "static/media/apartment_1.72a6e790.jpg";